import { render, staticRenderFns } from "./QuestionSteps.vue?vue&type=template&id=488f677a&scoped=true"
import script from "./QuestionSteps.vue?vue&type=script&lang=ts"
export * from "./QuestionSteps.vue?vue&type=script&lang=ts"
import style0 from "./QuestionSteps.vue?vue&type=style&index=0&id=488f677a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f677a",
  null
  
)

export default component.exports